import { render, staticRenderFns } from "./PainelDocumentosTabela.vue?vue&type=template&id=513f7444&scoped=true"
import script from "./PainelDocumentosTabela.vue?vue&type=script&lang=js"
export * from "./PainelDocumentosTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelDocumentosTabela.vue?vue&type=style&index=0&id=513f7444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f7444",
  null
  
)

export default component.exports